<template lang="">
  <div class="bbs_write">
    <table class="bbs_tbl">
      <colgroup>
        <col style="width:140px">
        <col style="width:auto">
      </colgroup>
      <tbody>
        <tr>
          <th scope="row">종류</th>
          <td>
            <div class="item">
              <select name="" id="" class="i_sel" style="width:260px" v-model="type">
                <option value="wedding">결혼식장</option>
                <option value="funeral">장례식장</option>
              </select>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">기관명</th>
          <td>
            <div class="bbs_srch">
              <input type="text" class="i_txt" name="keyword" @keyup.enter="searchPlace" v-model="name">
              <button type="button" class="bt_base gray btn_srch" @click="searchPlace">검색</button>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row"></th>
          <td>
            <ul>
              <li v-for="place in places" :key="place.id" @click="selectPlace(place)">
                {{ place.place_name }}
              </li>
            </ul>
            <div id="map" style="width:500px;height:400px;"></div>
          </td>
        </tr>
        <tr>
          <th scope="row">주소</th>
          <td>
            <div class="bbs_srch">
              <input type="text" class="i_txt type_full lineless" name="addressName" v-model="addressName">
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">도로명 주소</th>
          <td>
            <div class="bbs_srch">
              <input type="text" class="i_txt type_full lineless" name="roadAddressName" v-model="roadAddressName">
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">연락처</th>
          <td>
            <div class="bbs_srch">
              <input type="text" class="i_txt type_full lineless" name="phone" v-model="phone">
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">url</th>
          <td>
            <div class="bbs_srch">
              <input type="text" class="i_txt type_full lineless" name="placeUrl" v-model="placeUrl">
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">상세위치</th>
          <td>
            <div class="bbs_srch">
              <div class="wrapper" style="margin-bottom:5px;" v-for="(row, index) in details" :key="index">
                <input type="text" class="i_txt" style="padding:5px;margin-right:5px;" v-model="row.name" placeholder="상세위치를 입력하세요">
                <button type="button" class="bt_base gray type_ico" style="margin-right:5px;" @click="removeRow(index)"> &minus; </button>
                <button type="button" class="bt_base secondary type_ico" @click="addRow" v-if="index === 0"> &plus; </button>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="bbs_controller">
    <div class="lft_area">
      <a class="bt_base gray large_h btn_list" @click="toList">목록</a>
    </div>

    <div class="rgt_area">
      <button type="button" class="bt_base primary large_h" @click="savePartner">저장</button>
      <button type="reset" class="bt_base gray large_h" v-if="partnerSeq" @click="deletePartner">삭제</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

const adminPartnerModule = "adminPartnerModule"

export default {
  data (){
    return {
      partnerSeq: this.$route.query.partnerSeq,
      type: 'wedding',
      name: null,
      latitude: 37.5665,
      longitude: 126.9780,
      map: null,
      places: [],
      addressName: '',
      roadAddressName: '',
      phone: '',
      placeUrl: '',
      details: [
        { name: '' }
      ],
    }
  },
  methods: {
    ...mapActions(adminPartnerModule, [
      'requestPartner',
      'requestSavePartner',
      'requestDeletePartners'
    ]),

    initMap (x, y) {
      var container = document.getElementById('map');
      var options = {
        center: new kakao.maps.LatLng(x, y),
        level: 4
      };
      this.map = new kakao.maps.Map(container, options);
    },

    searchPlace() {
      const ps = new kakao.maps.services.Places();
      ps.keywordSearch(this.name, (data, status) => {
        if (status === kakao.maps.services.Status.OK) {
          this.places = data;
        }
      });
    },

    async selectPlace(place) {
      this.name = place.place_name
      this.latitude = place.y
      this.longitude = place.x
      this.addressName = place.address_name
      this.roadAddressName = place.road_address_name
      this.phone = place.phone
      this.placeUrl = place.place_url

      if(this.marker && this.infoWindow) {
        await this.marker.setMap(null)
        this.infoWindow.close()
      }

      this.marker = new kakao.maps.Marker({
        position: new kakao.maps.LatLng(place.y, place.x),
        map: this.map,
      });

      if (this.name) {
        this.infoWindow = new kakao.maps.InfoWindow({
          content: `<div style="padding:5px;font-size:14px;">${place.place_name}</div>`,
        });
        this.infoWindow.open(this.map, this.marker);
      }

      this.map.setCenter(new kakao.maps.LatLng(place.y, place.x));
    },

    toList () {
      this.$router.push({ name: "PartnerManageListPage" })
    },

    async savePartner() {
      const { partnerSeq, type, name, latitude, longitude, addressName, roadAddressName, phone, placeUrl } = this
      const filteredDetails = this.details.filter(detail => detail.name && detail.name.trim() !== '');

      const result = await this.requestSavePartner({ partnerSeq, type, name, latitude, longitude, addressName, roadAddressName, phone, placeUrl, details: filteredDetails });
      if (result) {
        alert(result)
        this.$router.push({ name: "PartnerManageListPage" })
      }
    },

    async deletePartner () {
      const result = await this.requestDeletePartners([ this.partnerSeq ]);
      if (result) {
        alert("삭제되었습니다.")
        this.$router.push({ name: "PartnerManageListPage" })
      }
    },

    addRow() {
      this.details.push({ name: '' });
    },

    removeRow(index) {
      if (this.details.length > 1) {
        this.details.splice(index, 1);
      } else {
      this.details[index].name = '';
    }
    },
  },

  computed: {
    ...mapState(adminPartnerModule, ['partner']),
  },

  async mounted() {
    if (this.partnerSeq) {
      await this.requestPartner(this.partnerSeq)
      this.type = this.partner.type
      this.name = this.partner.name
      this.latitude = this.partner.latitude
      this.longitude = this.partner.longitude
      this.addressName = this.partner.addressName
      this.roadAddressName = this.partner.roadAddressName
      this.phone = this.partner.phone
      this.placeUrl = this.partner.placeUrl
      //this.searchPlace()

      if (this.partner.details && this.partner.details.length > 0) {
        this.details = this.partner.details.map(detail => ({ name: detail.name }));
      }
    }
    this.initMap(this.latitude, this.longitude)
    this.selectPlace({ place_name: this.name, x: this.longitude, y: this.latitude,
                       address_name: this.addressName, road_address_name: this.roadAddressName,
                       phone: this.phone, place_url: this.placeUrl  })
  },

}
</script>
<style lang="">

</style>